import { Type } from "@themes/pollinator/ui/Type";
import { marketingType } from "../../marketing.type";

export type Props = {
  /** The signup form itself, which the card frames */
  children: React.ReactNode;
  className?: string;
};

/**
 * The newsletter signup in an outlined card, as the design ends
 * the News section with it, on the homepage and under every post.
 *
 * The design gives the heading 20px to the sentence under it, the sentence
 * 24px to the form, and holds the sentence to 768px so it breaks in two.
 */
export function MarketingNewsletterCard({ children, className }: Props) {
  return (
    <div
      id="newsletter"
      className={`flex w-full flex-col gap-4 rounded-[36px] border border-brand-800 p-8 md:gap-5 lg:gap-6 ${className ?? ""}`}
      data-testid="marketing-newsletter-card"
    >
      <div className="flex flex-col gap-4 md:gap-5">
        <Type
          variant="h3"
          as="h2"
          className={`${marketingType.display} ${marketingType.displayWeight} ${marketingType.displayTrim}`}
        >
          Get the latest Pollinator updates.
        </Type>
        <Type variant="body1" className={`${marketingType.body} max-w-[768px]`}>
          Sign up for our newsletter to find out about upcoming programs,
          opportunities, and more.
        </Type>
      </div>
      {/* The design insets the form 10px inside the card's own padding. */}
      <div className="lg:p-2.5">{children}</div>
    </div>
  );
}

export default MarketingNewsletterCard;
